module.exports = __webpack_public_path__ + "static/media/sdg_icon_12.1b47e322.png";